import React from 'react';
import PropTypes from 'prop-types';
import { DonutLargeOutlined } from '@mui/icons-material';
import { Card, Divider, Box } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import './WinRatePieChart.css';

const WinRatePieChartBacktesting = ({ metrics = {} }) => {
  const { winRate = 0, lossRate = 0, breakevenRate = 0 } = metrics;

  const data = [
    { id: 'Wins', value: winRate, color: '#5FB663' },
    { id: 'Losses', value: lossRate, color: '#EA4643' },
    { id: 'Breakeven', value: breakevenRate, color: '#FFA726' },
  ];

  const renderHighlightedLabel = (params) => {
    const { id, value } = params;
    return `${id}: ${value.toFixed(0)}%`;
  };

  return (
    <Card style={{ minHeight: '300px' }}>
      <MDBox display="flex" flexDirection="column" justifyContent="space-between" pt={1} px={2} height="100%">
        <MDBox display="flex" justifyContent="space-between">
          <MDBox
            variant="gradient"
            bgColor="light"
            color="dark"
            coloredShadow="light"
            borderRadius="xl"
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="4rem"
            height="4rem"
            mt={-3}
          >
            <DonutLargeOutlined fontSize="medium" color="inherit" />
          </MDBox>
          <MDBox textAlign="right" lineHeight={1.25}>
            <MDTypography variant="button" fontWeight="light" color="text" fontFamily="inherit">
              Win Rate
            </MDTypography>
          </MDBox>
        </MDBox>
        <Divider />
        <MDBox pb={2} px={2} display="flex" justifyContent="center" alignItems="center">
          <MDBox mr={2}>
            {data.map(item => (
              <Box key={item.id} display="flex" alignItems="center" mb={1}>
                <Box
                  width={16}
                  height={16}
                  sx={{ backgroundColor: item.color, borderRadius: '2px' }}
                  mr={1}
                />
                <MDTypography variant="body2" color="text" className="label-text-pie">
                  {item.id}: {item.value.toFixed(0)}%
                </MDTypography>
              </Box>
            ))}
          </MDBox>
          <MDBox
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: 'auto', // Adjust width to ensure space for PieChart
              height: 'auto'
            }}
          >
            <PieChart
              width={280}
              height={200}
              series={[
                {
                  innerRadius: 60,
                  outerRadius: 80,
                  data: data,
                  dataKey: 'value',
                  cornerRadius: 5,
                  paddingAngle: 5,
                  startAngle: 90,
                  endAngle: 450,
                  colors: data.map(item => item.color),
                }
              ]}
              highlightOptions={{
                highlightEnabled: true,
                highlightBy: 'value',
                highlightColors: data.map(item => item.color),
                highlightLabelFormatter: renderHighlightedLabel,
              }}
            />
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
};

WinRatePieChartBacktesting.propTypes = {
  metrics: PropTypes.shape({
    winRate: PropTypes.number,
    lossRate: PropTypes.number,
    breakevenRate: PropTypes.number,
  }),
};

export default WinRatePieChartBacktesting;